<template>
	<div>
		<div class="area">
			<!-- <div class="CoBrand"></div> -->
			<img class="CoBrand1" mode="widthFix" src="../../static/bottomPic/logo_hudie1@2x.png"/>
			<div class="qrCodeArea">
				<div class="qrCodeBox">
					<img class="qrCode" mode="widthFix" src="../../static/downLoadPic/customer.png"/>
					<div class="qrCodetxt">扫码下载APP</div>
				</div>
				<div class="qrCodeBox">
					<img class="qrCode" mode="widthFix" src="../../static/downLoadPic/seller.jpg"/>
					<div class="qrCodetxt">商家端下载</div>
				</div>
				<div class="qrCodeBox">
					<img class="qrCode" mode="widthFix" src="../../static/bottomPic/download_gzh@2x.png"/>
					<div class="qrCodetxt">微信公众号</div>
				</div>
				<div class="qrCodeBox">
					<img class="qrCode" mode="widthFix" src="../../static/bottomPic/img_douyinhao@2x.png"/>
					<div class="qrCodetxt">官方抖音号</div>
				</div>
			</div>
			<div class="linkArea">
				<!-- <a class="linkA" @click="go(0)">电商平台</a> -->
				<router-link class="linkA" :to="{name: 'platform'}">电商平台</router-link>
				<router-link class="linkA" :to="{name: 'about'}">关于我们</router-link>
				<router-link class="linkA" :to="{name: 'canvass'}">招商入驻</router-link>
				<router-link class="linkA" :to="{name: 'newsCenter'}">新闻中心</router-link>
				<router-link class="linkA" :to="{name: 'recruit'}">人才招聘</router-link>
			</div>
			<div class="contactArea">
				<div class="contactBox">
					<div class="contactTitle">官方热线</div>
					<div class="contactNum">400-688-6999</div>
				</div>
				<div class="contactBox">
					<div class="contactTitle">商务合作</div>
					<div class="contactNum">18200000003</div>
				</div>
			</div>
		</div>
		<div class="beianLan">
			<a class="beianhao" href="https://beian.miit.gov.cn">渝ICP备2020011206号</a>
			<div class="beianWeb" >Copyright © 2020-2021 蝴蝶供应链有限公司版权所有</div>
		</div>
	</div>
</template>

<script>
	export default {
		name:'bottom-area',
		data() {
			return {

			}
		},
		created() {

		},
		methods: {
			// go(data){
			// 	if(data==0){
			// 		this.$router.push(path:{../view/about})
			// 	}else if(data==1){
					
			// 	}else if(data==2){
					
			// 	}else if(data==3){
					
			// 	}else{
					
			// 	}
			// }
		}
	}
</script>

<style>
a{
	text-decoration:none
}
.area{
	width: 100%;
	height: 432px;
	background: #242B34;
	position: relative;
}
.CoBrand1{
	width: 500px;
	height: 80px;
	position: absolute;
	top: 110px;
	left: 18.2%;
}
.qrCodeArea{
	position: absolute;
	width: 500px;
	height: 130px;
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	top: 234px;
	left: 18.2%;
}
.qrCodeBox{
	width: 106px;
	height: 130px;
	display: flex;
	flex-direction: column;
}
.qrCode{
	width: 106px;
	/* height: 106px; */
}
.qrCodetxt{
	width: 100%;
	text-align: center;
	margin-top: 16px;
	font-size: 16px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #FFFFFF;
}
.linkArea{
	position: absolute;
	top: 110px;
	/* right: 633px; */
	left: 63.7%;
	display: flex;
	flex-direction: column;
	width: 70px;
}
.linkA{
	width: 100%;
	text-align: center;
	margin-bottom: 34px;
	font-size: 16px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #FFFFFF;
}
.contactArea{
	width: 220px;
	position: absolute;
	top: 112px;
	/* right: 312px; */
	left: 71.7%;
	display: flex;
	flex-direction: column;
}
.contactBox{
	width: 100%;
	display: flex;
	flex-direction: column;
	margin-bottom: 44px;
}
.contactTitle{
	width: 100%;
	font-size: 16px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #FFFFFF;
	text-align: left;
}
.contactNum{
	width: 100%;
	margin-top: 20px;
	font-size: 30px;
	font-family: Source Han Sans SC;
	font-weight: 500;
	color: #FFFFFF;
	text-align: left;
}
.beianLan{
	width: 100%;
	height: 50px;
	background: #15161A;
	line-height: '50px';
	display: flex;
	justify-content: center;
	align-items: center;
	flex-direction: row;
}
.beianhao{
	font-size: 14px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #FFFFFF;
}
.beianWeb{
	font-size: 14px;
	font-family: Source Han Sans SC;
	font-weight: bold;
	color: #FFFFFF;
	margin-left: 32px;
}
</style>
